import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { Product } from '~shared/models';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';

export class ProductClickApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.ProductClick;

  constructor(
    private url: string,
    private product: Product,
    private priceType: PriceTypes,
    private pageName: string,
    private isBlackDealsEnabled: boolean,
    private index?: number,
    private label?: string,
    private searchTerm?: string,
    private triggerPromotionEvent?: boolean) {}

  getPayload(): any {
    return {
      url: this.url,
      product: this.product,
      priceType: this.priceType,
      pageName: this.pageName,
      isBlackDealsEnabled: this.isBlackDealsEnabled,
      index: this.index,
      label: this.label,
      searchTerm: this.searchTerm,
      triggerPromotionEvent: this.triggerPromotionEvent,
    };
  }
}
